import React from 'react';
import logo from '../icons/logo.svg'; // Logo import

interface LoginScreenProps {
  onLoginClick: () => void;
}

const LoginScreen: React.FC<LoginScreenProps> = ({ onLoginClick }) => {
  // Calculate size for the logo (1/10th of the smaller screen dimension)
  const size = Math.min(window.innerWidth, window.innerHeight) / 10;
  const gitSha = process.env.REACT_APP_GIT_SHA ?? "dev";
  const builtAt = process.env.REACT_APP_BUILD_AT ?? "";

  return (
    <div className="login-screen d-flex flex-column justify-content-center align-items-center" style={{ height: '50vh' }}>
      <div style={{ marginTop: '10vh' }}>
        <img 
          src={logo} 
          alt="Logo" 
          style={{ 
            width: size, 
            height: size, 
            border: '1px solid black', 
            borderRadius: '10px' 
          }} 
        />
      </div>
      <button onClick={onLoginClick} className="btn btn-primary mt-5">
        Zaloguj ...
      </button>
      <div className="text-muted mt-3" style={{ fontSize: "0.85rem" }}>
        build: {gitSha}{builtAt ? ` (${builtAt})` : ""}
      </div>
    </div>
  );
};

export default LoginScreen;
